/*
 * Before/after slider: drag with a finger from anywhere on the image
 * (owner 2026-10-13, homepage "finger won't affect the slider").
 *
 * Horizon's comparison slider is an invisible <input type="range"> over both
 * images. iOS Safari moves a range input only when the drag starts ON its thumb
 * (Chrome on Android also accepts the track), and the thumb is a 44px circle
 * under the handle, so most swipes across the image did nothing on an iPhone.
 * For touch and pen, once the finger has clearly moved along the slider (more
 * along it than across), the range value follows the finger and `input` fires,
 * which the component already listens to (its on:input="/sync"); a plain tap
 * sets it once. A swipe across the slider (scrolling the page) never moves it:
 * the browser takes that pan (touch-action in assets/sis-skin.css) and sends
 * pointercancel. Mouse keeps the native range behaviour.
 */
(() => {
  const SLIDER = 'comparison-slider-component .cs-slider';

  const setFromPoint = (input, event) => {
    const wrapper = input.closest('.comparison-slider__media-wrapper');
    if (!wrapper) return;
    const rect = wrapper.getBoundingClientRect();
    const vertical = wrapper.dataset.orientation === 'vertical';
    let ratio = vertical
      ? (rect.bottom - event.clientY) / rect.height
      : (event.clientX - rect.left) / rect.width;
    ratio = Math.min(1, Math.max(0, ratio));
    const min = Number(input.min) || 0;
    const max = Number(input.max) || 100;
    const value = String(Math.round(min + ratio * (max - min)));
    if (input.value === value) return;
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  };

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (event.pointerType === 'mouse') return;
      const input = event.target instanceof Element && event.target.closest(SLIDER);
      if (!input) return;
      const vertical = input.closest('[data-orientation]')?.dataset.orientation === 'vertical';
      let dragging = false;
      let moved = false;
      const move = (e) => {
        if (e.pointerId !== event.pointerId) return;
        if (!dragging) {
          const along = Math.abs(vertical ? e.clientY - event.clientY : e.clientX - event.clientX);
          const across = Math.abs(vertical ? e.clientX - event.clientX : e.clientY - event.clientY);
          if (along + across > 6) moved = true;
          if (along < 6 || along < across) return; // not (yet) a drag along the slider
          dragging = true;
        }
        setFromPoint(input, e);
      };
      const end = (e) => {
        if (e.pointerId !== event.pointerId) return;
        if (e.type === 'pointerup' && !dragging && !moved) setFromPoint(input, e); // a tap
        input.removeEventListener('pointermove', move);
        input.removeEventListener('pointerup', end);
        input.removeEventListener('pointercancel', end);
      };
      input.addEventListener('pointermove', move);
      input.addEventListener('pointerup', end);
      input.addEventListener('pointercancel', end);
    },
    { passive: true }
  );
})();
